import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.StoryFilters;

// initial state
// object name must match specification name
const filters = {
	State: new FormControl.FilterGroup('State', 'Filter by State', 'All States', '', false, true, 'checkbox'),
	StoryTopic: new FormControl.FilterGroup('StoryTopic', 'Filter by Topic', 'All Topics', '', false, true, 'checkbox'),
	searchTerm: new FormControl.FilterGroup(
		'SearchTerm', 'Search by Keyword', null, null, false, true, 'textbox',
		new FormControl.Textbox('Search')
	),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };